import React, { Component } from "react";

import { firebase } from "../../firebase";

import FileUploader from "react-firebase-file-uploader";
import CircularProgress from "@material-ui/core/CircularProgress";

import CloudUploadIcon from "@material-ui/icons/CloudUpload";

import Button from "@material-ui/core/Button";

class Fileuploader extends Component {
  state = {
    name: "",
    isUploading: false,
    fileUrl: "",
    ErrorMessage: false
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true
    });
  };

  handleUploadError = () => {
    this.setState({
      ErrorMessage: true,
      isUploading: false
    });
  };

  handleUploadSuccess = filename => {
    this.setState({
      name: filename,
      isUploading: false
    });

    firebase
      .storage()
      .ref(this.props.dir)
      .child(filename)
      .getDownloadURL()
      .then(url => {
        this.setState({
          fileUrl: url
        });
      });

    this.props.fileName(filename);
  };

  uploadAgain = () => {
    this.setState({
      name: "",
      isUploading: false,
      fileUrl: ""
    });
    this.props.resetImg();
  };

  static getDerivedStateFromProps(props, state) {
    if (props.defaultImage) {
      return (state = {
        name: props.defaultImageName,
        fileUrl: props.defaultImage
      });
    }
    return null;
  }

  render() {
    return (
      <div>
        {!this.state.fileUrl ? (
          <React.Fragment>
            {this.state.isUploading ? (
              <div className="">
                <CircularProgress />
              </div>
            ) : (
              <React.Fragment>
                <label
                  style={{
                    backgroundColor: "steelblue",
                    color: "white",
                    padding: "5px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "50%"
                  }}
                >
                  Upload
                  <FileUploader
                    hidden
                    accept="image/*"
                    name="image"
                    randomizeFilename
                    storageRef={firebase.storage().ref(this.props.dir)}
                    onUploadStart={this.handleUploadStart}
                    onUploadError={this.handleUploadError}
                    onUploadSuccess={this.handleUploadSuccess}
                  />
                  <CloudUploadIcon />
                </label>
              </React.Fragment>
            )}
          </React.Fragment>
        ) : null}

        {this.state.fileUrl ? (
          <div className="uploaded_image_wrapper">
            <img
              style={{
                width: "100%"
              }}
              src={this.state.fileUrl}
              alt={this.state.name}
            />
            <Button
              variant="contained"
              color="secondary"
              size="small"
              className="remove_uploaded"
              style={{
                margin: "10px",
                display: "inline-block"
              }}
              onClick={() => this.uploadAgain()}
            >
              Удалить
            </Button>
          </div>
        ) : null}

        {this.state.ErrorMessage ? (
          <div className="error_message">Что-то пошло не так</div>
        ) : null}
      </div>
    );
  }
}

export default Fileuploader;
